import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { PDFDownloadLink } from '@react-pdf/renderer';
import { Header } from '../components/shared/Header/Header';
import { AssessmentInstructionsPDF } from '../components/AssessmentInstructionsPDF';
import { SmartGoalsPDF } from '../components/SmartGoalsPDF';

const ResourcesPage: FC = () => {
  const { t } = useTranslation();

  return (
    <div className="rounded-2xl">
      <Header />

      <div className="pt-6">
        <div className="bg-white rounded-2xl shadow-sm overflow-hidden">
          <div className="px-4 sm:px-6 py-4 border-b">
            <h2 className="text-base sm:text-lg font-semibold text-gray-800">
              {t('resources.availableResources')}
            </h2>
          </div>

          <div className="p-4 sm:p-6">
            <div className="space-y-6">
              <div className="bg-white rounded-lg border border-gray-200 p-6">
                <div className="flex items-start justify-between">
                  <div>
                    <h3 className="text-lg font-medium text-gray-900">
                      {t('resources.assessmentInstructions')}
                    </h3>
                    <p className="mt-2 text-sm text-gray-600">
                      {t('resources.assessmentInstructionsDescription')}
                    </p>
                  </div>
                  <PDFDownloadLink
                    document={<AssessmentInstructionsPDF />}
                    fileName="assessment-instructions.pdf"
                    className="flex items-center px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors"
                  >
                    {({ loading }) => (
                      <>
                        <svg
                          className="w-5 h-5 mr-2"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                          />
                        </svg>
                        {loading ? t('common.generating') : t('common.download')}
                      </>
                    )}
                  </PDFDownloadLink>
                </div>
              </div>

              <div className="bg-white rounded-lg border border-gray-200 p-6">
                <div className="flex items-start justify-between">
                  <div>
                    <h3 className="text-lg font-medium text-gray-900">
                      {t('resources.smartGoals')}
                    </h3>
                    <p className="mt-2 text-sm text-gray-600">
                      {t('resources.smartGoalsDescription')}
                    </p>
                  </div>
                  <PDFDownloadLink
                    document={<SmartGoalsPDF />}
                    fileName="smart-goals-guide.pdf"
                    className="flex items-center px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors"
                  >
                    {({ loading }) => (
                      <>
                        <svg
                          className="w-5 h-5 mr-2"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                          />
                        </svg>
                        {loading ? t('common.generating') : t('common.download')}
                      </>
                    )}
                  </PDFDownloadLink>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResourcesPage;